import { render, staticRenderFns } from "./CompareEventsDropdown.vue?vue&type=template&id=1b6e1d23&scoped=true&"
import script from "./CompareEventsDropdown.vue?vue&type=script&lang=js&"
export * from "./CompareEventsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CompareEventsDropdown.vue?vue&type=style&index=0&id=1b6e1d23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6e1d23",
  null
  
)

export default component.exports